import {Col} from "react-bootstrap";
import {AuditImages, AuditVideos} from "Pages/Audits/Media/AuditMedia";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

export const AuditItemMediaSlideViewer = ({
    isViewOnly,
    handleDelete,
    item,
    annotationType,
    updateElementImages,
    loadingProgress,
    isVideoCompressed,
    updateElementVideos,
    loadingVideo,
    videoCompressionFeature,
}) => {
    return <Col>
        <>
            <AuditImages
                rowImages={[...item[`${annotationType}_images`]]}
                updateElementImages={updateElementImages}
                elementType={annotationType}
                isViewOnly={isViewOnly}
                deleteMedia={handleDelete}
                isFullViewer={true}
                uploadCountLimit={item.max_images_count}
            />
            {loadingVideo && videoCompressionFeature ?
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                    }}
                ><CircularProgress
                        variant="determinate"
                        value={loadingProgress}
                        sx={{color: "#8CFAD0"}}
                    />
                    <p style={{margin: 0}}>
                        {isVideoCompressed ? "Saving" : "We are compressing your video"}....
                    </p>
                </Box> :
                <AuditVideos
                    rowVideos={item[`${annotationType}_videos`]}
                    updateElementVideos={updateElementVideos}
                    elementType={annotationType}
                    isViewOnly={isViewOnly}
                    deleteMedia={handleDelete}
                    isFullViewer={true}
                    uploadCountLimit={item.max_videos_count}
                    maxVideoDuration={item.max_video_duration}
                />
            }
        </>
    </Col>;
};

AuditItemMediaSlideViewer.propTypes = {
    isViewOnly: PropTypes.bool.isRequired,
    item: PropTypes.shape({
        displayNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        image_annotation_images: PropTypes.arrayOf(PropTypes.string),
        video_annotation_videos: PropTypes.arrayOf(PropTypes.string),
        max_images_count: PropTypes.number,
        max_videos_count: PropTypes.number,
        max_video_duration: PropTypes.number,
    }).isRequired,
    annotationType: PropTypes.string.isRequired,
    handleDelete: PropTypes.func,
    updateElementImages: PropTypes.func,
    loadingProgress: PropTypes.number,
    isVideoCompressed: PropTypes.bool,
    updateElementVideos: PropTypes.func,
    loadingVideo: PropTypes.bool,
    videoCompressionFeature: PropTypes.bool,
};
